import { useEffect, useState } from "react";
import { FilePdf, Translate } from "@phosphor-icons/react";
import { http } from "@/lib/api";

/** Split pill: PDF download link + classroom-language picker (55 languages).
 * The selected language is appended as ?lang= so teachers get a translated,
 * correctly-shaped printable guide (server caches each translation). */
export default function GuidePdfDownload({ url, label, testid, color = "#166534", big = false }) {
  const [langs, setLangs] = useState([]);
  const [lang, setLang] = useState("en");

  useEffect(() => {
    http.get("/translate/languages").then(({ data }) => setLangs(data.languages || [])).catch(() => {});
  }, []);

  const href = lang === "en" ? url : `${url}?lang=${lang}`;
  const pad = big ? "px-6 py-3.5 text-[11px]" : "px-5 py-2.5 text-[10px]";

  return (
    <span className="inline-flex items-stretch rounded-full border bg-white overflow-hidden" style={{ borderColor: `${color}4D` }}
      data-testid={`${testid}-wrap`}>
      <a href={href} target="_blank" rel="noreferrer" data-testid={testid}
        className={`inline-flex items-center gap-2 ${pad} font-mono-tech tracking-[0.24em] uppercase hover:bg-black/[0.04] transition-colors`}
        style={{ color }}>
        <FilePdf size={big ? 14 : 13} weight="bold" /> {label}
      </a>
      <span className="w-px self-stretch" style={{ background: `${color}33` }} />
      <span className="inline-flex items-center gap-1 pl-2.5 pr-2" style={{ color }}>
        <Translate size={13} weight="bold" />
        <select value={lang} onChange={(e) => setLang(e.target.value)} data-testid={`${testid}-lang`}
          aria-label="PDF language"
          className="appearance-none bg-transparent font-mono-tech text-[10px] tracking-[0.14em] uppercase outline-none cursor-pointer max-w-[76px]">
          <option value="en">EN</option>
          {langs.filter((l) => l.code !== "en").map((l) => (
            <option key={l.code} value={l.code}>{l.code.toUpperCase()}</option>
          ))}
        </select>
      </span>
    </span>
  );
}
